export default "__VITE_ASSET__ba0a1983__"